import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchCotizacion,
  fetchCoverage,
  selectpackage
} from '../../api/quoteApi';

import { 
  trackEventStep2View,
  trackEventStep2Select
} from '../../utils/analytics';

export const initializeCoverage = createAsyncThunk(
  'coverage/initializeCoverage',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { quote } = getState();
      const response = await fetchCotizacion(quote.quoteDataInitial);

      if (!response.success) {
        return rejectWithValue("No se pudo crear la cotización");
      }

      await trackEventStep2View(); 
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCoverage = createAsyncThunk(
  'coverage/getAll',
  async ({ uuid }, { rejectWithValue }) => {
    try {
        const response = await fetchCoverage({ uuid });
        const hasZeroPrice = response.some(plan => {
          const price = Number(plan.price);
          return price === 0;
        });
        
        if (hasZeroPrice) {
          return rejectWithValue("ZERO_PREMIUM");
        }

        return response;
    } catch (error) {
        return rejectWithValue(error.message);
    }
  }
);

export const postPackage = createAsyncThunk(
  'coverage/SelectPackage',
  async ({ packageId }, { getState, rejectWithValue }) => {
    try {
      const { coverage } = getState();
      const uuid = coverage.uuid;

      await new Promise(resolve => setTimeout(resolve, 2000));

      const response = await selectpackage({ packageId, uuid });

      if (response.success) {
        await trackEventStep2Select(packageId); 
        return response;
      } else {
        return rejectWithValue(response.message || 'Error al seleccionar el paquete');
      }
    } catch (error) {
        return rejectWithValue(error.message);
    }
  }
);


const initialState = {
  
  step: 2,

  error: null,

  status: 'idle',

  uuid: '',

  plans: [],

  selectedPlan: [],

  postPackageStatus: 'idle'

};

const coverageSlice = createSlice({
  name: 'coverage',
  initialState,
  reducers: {
        nextStep: (state) => {
          if (state.step < 4) {
            state.step += 1;
          }
        },
        prevStep: (state) => {
          if (state.step > 1) {
            state.step -= 1;
          }
        },
        setStep: (state, action) => {
          state.step = action.payload;
        },
        updateCoverage: (state, action) => {
          state.plans = { ...state.plans, ...action.payload };
        },
        setSelectedPlan: (state, action) => {
          state.selectedPlan = action.payload;
        },
        resetPostPackageStatus: (state) => {
          state.postPackageStatus = 'idle';
          state.error = null;
        },
        resetError: (state) => {
            state.error = null;
        },
        resetProcess: () => {
            return {
            ...initialState,
            };
        }
    },

    extraReducers: (builder) => {
      builder
        .addCase(initializeCoverage.pending, (state) => {
          state.status = 'loading';
          state.error = null;
        })
        .addCase(initializeCoverage.fulfilled, (state, action) => {
          state.status = 'ready';
          state.error = null;
          state.uuid = action.payload.uuid;
        })
        .addCase(initializeCoverage.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.payload || "Error desconocido";
        })
        .addCase(getCoverage.pending, (state) => {
          state.status = 'loading';
          state.error = null;
        })
        .addCase(getCoverage.fulfilled, (state, action) => {
          state.status = 'ready';
          state.error = null;
          state.plans = action.payload;
        })
        .addCase(getCoverage.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.payload || "Error desconocido";
        })
        .addCase(postPackage.pending, (state) => {
          state.postPackageStatus = 'loading';
          state.error = null;
        })
        .addCase(postPackage.fulfilled, (state, action) => {
          state.postPackageStatus = 'succeeded';
          state.error = null;
          state.selectedPlan = action.payload;
        })
        .addCase(postPackage.rejected, (state, action) => {
          state.postPackageStatus = 'failed';
          state.error = action.payload || "Error al seleccionar el paquete";
        });
      }
});

export const {
  nextStep,
  prevStep,
  setStep,
  updateCoverage,
  setSelectedPlan,
  setLoading,
  resetError, 
  resetProcess,
  resetPostPackageStatus
} = coverageSlice.actions;

export default coverageSlice.reducer;